export default {
    getModalGenerateBalanceData(state) {
        return state.modalGenerateBalanceData;
    },
    getModalGenerateBalanceErrors(state) {
        return state.errors;
    }
}